<table class="table table-condensed table-striped table-sm">
    <tr><th>Sub Topics</th><th class="text-center">Questions Attempted</th><th class="text-center">Questions Passed</th><th class="text-center">% Pass</th></tr>

     <tr *ngFor="let subtopic of topic.subtopics">
        <td>{{subtopic.name}} </td>
        <td class='text-center'>{{subtopic.questionsAttemptedCount}}</td>
        <td class="text-center">{{subtopic.questionsPassedCount}}</td>
        <td class="text-center">{{subtopic.percentagePass}}</td>
        </tr>
    <tr>
        <td><b>Overall</b></td>
        <td class='text-center'><b>{{topic.questionsAttemptedCount}}</b></td>
        <td class="text-center"><b>{{topic.questionsPassedCount}}</b></td>
        <td class="text-center"><b>{{topic.percentagePass}} </b></td>
   </tr>
  </table>

